import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import { ReworkPathHint } from "./PathHint";
import { LocationAutocompleteDto } from "../locations/LocationDtos";
import { BossDto } from "./BossAutocomplete";
import { isNil } from "lodash";
import { OotItemDto } from "./OotItemAutocomplete";

export interface GoalHintDto{
    location: LocationAutocompleteDto | null,
    goal: BossDto | null,
    items: Array<OotItemDto | null>
}

export const DefaultGoalHintDto: GoalHintDto = {location: null, goal: null, items: [null,null,null,null,null]}

export interface PathHintsTrackerProps {

    goalHints?: Array<GoalHintDto>
    setLocation?: (v: LocationAutocompleteDto | null, index: number) => void
    setGoal?: (v: BossDto | null, index: number) => void
    setItem?: (v: OotItemDto | null, index: number, indexItem: number) => void
    nbGoals?: number
    players?: Array<string>
    woth?: boolean

}

const PathHintsTracker = (props: PathHintsTrackerProps) => {

    let nbGoals= useSelector((state: AppState) => state.ui.ootr.main.nbGoals);
    if(!isNil(props.nbGoals))
        nbGoals = props.nbGoals;
    else
        nbGoals = Math.min(nbGoals, 10)
    
    if(!isNil(props.goalHints) && !isNil(props.setGoal) && !isNil(props.setLocation) && (props.players?.length ?? 1 ) === 1)
        return <Box display="flex" flexWrap={"nowrap"} flexBasis={"fit-content"} alignContent={"flex-start"} flexDirection={"column"} margin={"10px"} textAlign={"center"}>
            {props.goalHints.map((e, i) => {
                return <ReworkPathHint id={i} 
                location={e.location} 
                goal={e.goal} 
                setLocation={(v) => {if(!isNil(props.setLocation)) props.setLocation(v,i)}} 
                setGoal={(v) => {if(!isNil(props.setGoal)) props.setGoal(v,i)}} 
                items={e.items}
                setItems={(v, ii) => {if(!isNil(props.setItem)) props.setItem(v,i, ii)}}
                isMultiworld={!isNil(props.players) && props.players.length > 1} players={props.players}
                woth={props.woth}
                />
            })}

        </Box>

    return <Box display="flex" flexWrap={"nowrap"} flexBasis={"fit-content"} alignContent={"flex-start"} flexDirection={"column"} margin={"10px"} textAlign={"center"}>

        {Array.from(Array(nbGoals), (e, i) => {
            return <ReworkPathHint id={i} isMultiworld={!isNil(props.players) && props.players.length > 1} players={props.players} woth={props.woth}/>
        })}

    </Box>
}

export default PathHintsTracker